import { Controller } from "@hotwired/stimulus"

// Adds/removes rows for a has_many association edited via accepts_nested_attributes_for.
// The <template> holds one blank row with "NEW_RECORD" placeholders in its field
// names; each add() swaps in a unique index so Rails treats it as a new nested record.
export default class extends Controller {
  static targets = ["items", "template"]

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this._uniqueId())
    this.itemsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-nested-form-target='item']")
    if (!item) return

    // A persisted row carries a hidden [id]: keep it in the payload but flag it
    // for destruction and hide it. A brand-new row can just leave the DOM.
    const hasId = item.querySelector("input[name*='[id]']")
    const destroyField = item.querySelector("input[name*='[_destroy]']")

    if (hasId && destroyField) {
      destroyField.value = "1"
      item.classList.add("hidden")
    } else {
      item.remove()
    }
  }

  _uniqueId() {
    return `${Date.now()}${Math.floor(Math.random() * 1000)}`
  }
}
